export const MAX_SIZE_LIMIT = 5 * 1024 * 1024;
